import { render, staticRenderFns } from "./SocialWall.vue?vue&type=template&id=1f4cea9a&scoped=true&lang=pug&"
import script from "./SocialWall.vue?vue&type=script&lang=js&"
export * from "./SocialWall.vue?vue&type=script&lang=js&"
import style0 from "./SocialWall.vue?vue&type=style&index=0&id=1f4cea9a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4cea9a",
  null
  
)

export default component.exports